<mat-form-field subscriptSizing="dynamic" class="flex flex-auto">
  <mat-label>{{ label$ | async }}</mat-label>
  <mat-select
    [formControl]="reasonCtrl"
    [required]="true"
    [compareWith]="compareFn"
    panelClass="scheduling-event-reason-panel"
    (selectionChange)="selected($event)"
  >
    <mat-select-trigger>{{ selectedReasonName$ | async }}</mat-select-trigger>

    @for (reason of reasons$ | async; track reason.ref.path) {
      <mat-option class="reason-option" [value]="reason.ref">
        <div class="flex flex-col gap-0.5 py-2">
          <span class="text-sm font-medium">{{ reason.name }}</span>

          <span class="text-xs text-slate-500">
            {{ reason | map: reasonDetail : this }}
          </span>

          @if (showDepositOutcome$ | async) {
            <span class="text-xs text-amber-700">
              {{ reason | map: forfeitureOutcomeLine$ : this | async }}
            </span>
          }
          @if (reason | map: isDefaultReason$ : this | async) {
            <span class="text-primary-500 text-xs">
              Default for conditions at time of scheduling.
            </span>
          }
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
